const getBaseUrl = () => {
    // process.env.NODE_ENV is automatically set by React
    // 'development' for npm start
    // 'production' for npm run build
    return process.env.NODE_ENV === 'development' 
      ? 'http://localhost:3001'
      : 'https://api.piggymate.org';
  };
  
  export const config = {
    baseUrl: getBaseUrl()
  }; 